const Items =
  [
    {
      '_id': '5c7485e1d8da9b1e3577f203',
      'uuid': '5c7485e1d8da9b1e3577f203',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (884) 512-2301',
      'birthdayDate': '03-05-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Talley',
      'lastname1': 'Tyson',
      'lastname2': 'Burgess',
      'username': 'Talley_Tyson',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '180 Harbor Lane',
      'cp': '',
      'photo': 'a5.jpg',
      'avatar': '/static/avatar/a5.jpg',
      'createdAt': '25-01-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '08-04-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '22-10-2018',
      'email': 'talley.tyson@google.com'
    },
    {
      '_id': '5c7485e17a94c0f9e0092e8e',
      'uuid': '5c7485e17a94c0f9e0092e8e',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (968) 481-2994',
      'birthdayDate': '09-07-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Willa',
      'lastname1': 'Sexton',
      'lastname2': 'Coleman',
      'username': 'Willa_Sexton',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '413 Kingsland Avenue',
      'cp': '',
      'photo': 'a2.jpg',
      'avatar': '/static/avatar/a2.jpg',
      'createdAt': '30-09-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '10-08-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '03-03-2018',
      'email': 'willa.sexton@google.com'
    },
    {
      '_id': '5c7485e15a314b18cd552beb',
      'uuid': '5c7485e15a314b18cd552beb',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (981) 583-3230',
      'birthdayDate': '22-07-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Cervantes',
      'lastname1': 'Daugherty',
      'lastname2': 'Dillard',
      'username': 'Cervantes_Daugherty',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '794 Stillwell Place',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '22-01-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '06-12-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '31-01-2019',
      'email': 'cervantes.daugherty@google.com'
    },
    {
      '_id': '5c7485e1fe49817d3688087c',
      'uuid': '5c7485e1fe49817d3688087c',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (943) 546-2192',
      'birthdayDate': '28-07-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Dolores',
      'lastname1': 'Santos',
      'lastname2': 'Noel',
      'username': 'Dolores_Santos',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '437 Midwood Street',
      'cp': '',
      'photo': 'a6.jpg',
      'avatar': '/static/avatar/a6.jpg',
      'createdAt': '12-01-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '10-04-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '30-06-2018',
      'email': 'dolores.santos@google.com'
    },
    {
      '_id': '5c7485e176d70039f77b3255',
      'uuid': '5c7485e176d70039f77b3255',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (898) 577-2095',
      'birthdayDate': '06-11-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Mabel',
      'lastname1': 'Trevino',
      'lastname2': 'Pruitt',
      'username': 'Mabel_Trevino',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '580 Beverly Road',
      'cp': '',
      'photo': 'a5.jpg',
      'avatar': '/static/avatar/a5.jpg',
      'createdAt': '11-10-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '28-06-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '20-07-2018',
      'email': 'mabel.trevino@google.com'
    },
    {
      '_id': '5c7485e13483d1b137ba1204',
      'uuid': '5c7485e13483d1b137ba1204',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (912) 555-2634',
      'birthdayDate': '21-10-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Augusta',
      'lastname1': 'Craft',
      'lastname2': 'Boyd',
      'username': 'Augusta_Craft',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '857 Bush Street',
      'cp': '',
      'photo': 'a1.jpg',
      'avatar': '/static/avatar/a1.jpg',
      'createdAt': '16-02-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '27-06-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '09-01-2018',
      'email': 'augusta.craft@google.com'
    },
    {
      '_id': '5c7485e1bd34d33c4ce06fd0',
      'uuid': '5c7485e1bd34d33c4ce06fd0',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (919) 528-3789',
      'birthdayDate': '03-02-2019',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Andrews',
      'lastname1': 'Irwin',
      'lastname2': 'Lindsay',
      'username': 'Andrews_Irwin',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '258 Lincoln Avenue',
      'cp': '',
      'photo': 'a4.jpg',
      'avatar': '/static/avatar/a4.jpg',
      'createdAt': '29-07-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '20-09-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '27-10-2018',
      'email': 'andrews.irwin@google.com'
    },
    {
      '_id': '5c7485e1b052cceedc5e7e48',
      'uuid': '5c7485e1b052cceedc5e7e48',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (874) 542-3756',
      'birthdayDate': '21-09-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Flowers',
      'lastname1': 'Dotson',
      'lastname2': 'Cortez',
      'username': 'Flowers_Dotson',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '935 Adams Street',
      'cp': '',
      'photo': 'a3.jpg',
      'avatar': '/static/avatar/a3.jpg',
      'createdAt': '13-11-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '23-11-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '29-03-2018',
      'email': 'flowers.dotson@google.com'
    },
    {
      '_id': '5c7485e1494783dc198fd9e7',
      'uuid': '5c7485e1494783dc198fd9e7',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (810) 543-2659',
      'birthdayDate': '30-03-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Santana',
      'lastname1': 'Burks',
      'lastname2': 'Benson',
      'username': 'Santana_Burks',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '963 Navy Walk',
      'cp': '',
      'photo': 'a4.jpg',
      'avatar': '/static/avatar/a4.jpg',
      'createdAt': '13-04-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '29-08-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '12-01-2019',
      'email': 'santana.burks@google.com'
    },
    {
      '_id': '5c7485e12e01a2cc734eb37a',
      'uuid': '5c7485e12e01a2cc734eb37a',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (894) 576-3538',
      'birthdayDate': '27-12-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Mullins',
      'lastname1': 'Prince',
      'lastname2': 'Rowe',
      'username': 'Mullins_Prince',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '986 Ditmas Avenue',
      'cp': '',
      'photo': 'a9.jpg',
      'avatar': '/static/avatar/a9.jpg',
      'createdAt': '10-02-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '05-02-2019',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '04-01-2019',
      'email': 'mullins.prince@google.com'
    },
    {
      '_id': '5c7485e1df8bad97486bf906',
      'uuid': '5c7485e1df8bad97486bf906',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (942) 440-2052',
      'birthdayDate': '27-09-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Vinson',
      'lastname1': 'Key',
      'lastname2': 'Walter',
      'username': 'Vinson_Key',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '787 Havens Place',
      'cp': '',
      'photo': 'a6.jpg',
      'avatar': '/static/avatar/a6.jpg',
      'createdAt': '26-07-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '09-10-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '25-02-2019',
      'email': 'vinson.key@google.com'
    },
    {
      '_id': '5c7485e16a81e3966869d5b0',
      'uuid': '5c7485e16a81e3966869d5b0',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (812) 509-2994',
      'birthdayDate': '02-02-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Cassie',
      'lastname1': 'Sandoval',
      'lastname2': 'Young',
      'username': 'Cassie_Sandoval',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '543 Forbell Street',
      'cp': '',
      'photo': 'a1.jpg',
      'avatar': '/static/avatar/a1.jpg',
      'createdAt': '15-01-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '23-05-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '23-12-2018',
      'email': 'cassie.sandoval@google.com'
    },
    {
      '_id': '5c7485e186e7ba35eebecc10',
      'uuid': '5c7485e186e7ba35eebecc10',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (877) 457-2311',
      'birthdayDate': '10-02-2019',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Elisabeth',
      'lastname1': 'Adams',
      'lastname2': 'Reeves',
      'username': 'Elisabeth_Adams',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '618 Kent Street',
      'cp': '',
      'photo': 'a9.jpg',
      'avatar': '/static/avatar/a9.jpg',
      'createdAt': '05-08-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '08-04-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '31-07-2018',
      'email': 'elisabeth.adams@google.com'
    },
    {
      '_id': '5c7485e1463b22939882bfd3',
      'uuid': '5c7485e1463b22939882bfd3',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (916) 507-3182',
      'birthdayDate': '09-02-2019',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Kris',
      'lastname1': 'Chang',
      'lastname2': 'Hensley',
      'username': 'Kris_Chang',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '440 Richmond Street',
      'cp': '',
      'photo': 'a3.jpg',
      'avatar': '/static/avatar/a3.jpg',
      'createdAt': '13-12-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '30-01-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '17-02-2019',
      'email': 'kris.chang@google.com'
    },
    {
      '_id': '5c7485e1783da8aa44c281ed',
      'uuid': '5c7485e1783da8aa44c281ed',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (813) 580-3507',
      'birthdayDate': '23-01-2019',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Mcknight',
      'lastname1': 'Olsen',
      'lastname2': 'Wagner',
      'username': 'Mcknight_Olsen',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '151 Berriman Street',
      'cp': '',
      'photo': 'a2.jpg',
      'avatar': '/static/avatar/a2.jpg',
      'createdAt': '25-05-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '16-10-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '11-02-2019',
      'email': 'mcknight.olsen@google.com'
    },
    {
      '_id': '5c7485e120c9bc5e13e3a2d8',
      'uuid': '5c7485e120c9bc5e13e3a2d8',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (902) 470-2602',
      'birthdayDate': '07-05-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Christina',
      'lastname1': 'Lott',
      'lastname2': 'Kinney',
      'username': 'Christina_Lott',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '208 Seaview Court',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '12-06-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '29-05-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '28-04-2018',
      'email': 'christina.lott@google.com'
    },
    {
      '_id': '5c7485e1f8442131bd75754b',
      'uuid': '5c7485e1f8442131bd75754b',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (847) 589-2615',
      'birthdayDate': '08-08-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Sims',
      'lastname1': 'Strong',
      'lastname2': 'Gates',
      'username': 'Sims_Strong',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '630 Grant Avenue',
      'cp': '',
      'photo': 'a2.jpg',
      'avatar': '/static/avatar/a2.jpg',
      'createdAt': '27-08-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '07-01-2019',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '29-01-2019',
      'email': 'sims.strong@google.com'
    },
    {
      '_id': '5c7485e16d132604d368833a',
      'uuid': '5c7485e16d132604d368833a',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (906) 550-2787',
      'birthdayDate': '29-08-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Bullock',
      'lastname1': 'Burnett',
      'lastname2': 'Blackwell',
      'username': 'Bullock_Burnett',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '713 Ryder Street',
      'cp': '',
      'photo': 'a4.jpg',
      'avatar': '/static/avatar/a4.jpg',
      'createdAt': '16-05-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '21-07-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '11-06-2018',
      'email': 'bullock.burnett@google.com'
    },
    {
      '_id': '5c7485e1b4908237aa7baccb',
      'uuid': '5c7485e1b4908237aa7baccb',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (990) 565-2513',
      'birthdayDate': '25-08-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Coleman',
      'lastname1': 'Meadows',
      'lastname2': 'Figueroa',
      'username': 'Coleman_Meadows',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '213 Kane Street',
      'cp': '',
      'photo': 'a3.jpg',
      'avatar': '/static/avatar/a3.jpg',
      'createdAt': '03-02-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '05-02-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '04-03-2018',
      'email': 'coleman.meadows@google.com'
    },
    {
      '_id': '5c7485e1efdc392902ab6398',
      'uuid': '5c7485e1efdc392902ab6398',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (893) 422-2982',
      'birthdayDate': '31-12-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Sampson',
      'lastname1': 'Orr',
      'lastname2': 'Bright',
      'username': 'Sampson_Orr',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '861 Court Street',
      'cp': '',
      'photo': 'a1.jpg',
      'avatar': '/static/avatar/a1.jpg',
      'createdAt': '08-04-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '05-06-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '13-01-2018',
      'email': 'sampson.orr@google.com'
    },
    {
      '_id': '5c7485e195216408eeec0a01',
      'uuid': '5c7485e195216408eeec0a01',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (999) 595-3195',
      'birthdayDate': '03-01-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Potts',
      'lastname1': 'Deleon',
      'lastname2': 'Cruz',
      'username': 'Potts_Deleon',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '166 Moore Place',
      'cp': '',
      'photo': 'a3.jpg',
      'avatar': '/static/avatar/a3.jpg',
      'createdAt': '28-12-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '14-02-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '02-03-2018',
      'email': 'potts.deleon@google.com'
    },
    {
      '_id': '5c7485e1b76f7894fc016ac4',
      'uuid': '5c7485e1b76f7894fc016ac4',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (944) 541-3085',
      'birthdayDate': '27-03-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Gould',
      'lastname1': 'Rosario',
      'lastname2': 'Dale',
      'username': 'Gould_Rosario',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '423 Desmond Court',
      'cp': '',
      'photo': 'a6.jpg',
      'avatar': '/static/avatar/a6.jpg',
      'createdAt': '02-04-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '08-08-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '09-07-2018',
      'email': 'gould.rosario@google.com'
    },
    {
      '_id': '5c7485e1c893bc2812a9800f',
      'uuid': '5c7485e1c893bc2812a9800f',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (875) 493-2633',
      'birthdayDate': '20-02-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Caldwell',
      'lastname1': 'Livingston',
      'lastname2': 'Shannon',
      'username': 'Caldwell_Livingston',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '553 Stoddard Place',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '12-08-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '23-02-2019',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '18-01-2019',
      'email': 'caldwell.livingston@google.com'
    },
    {
      '_id': '5c7485e1ee0df66b1f6a278d',
      'uuid': '5c7485e1ee0df66b1f6a278d',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (858) 588-3947',
      'birthdayDate': '18-10-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Calhoun',
      'lastname1': 'Gordon',
      'lastname2': 'Lewis',
      'username': 'Calhoun_Gordon',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '128 Newton Street',
      'cp': '',
      'photo': 'a1.jpg',
      'avatar': '/static/avatar/a1.jpg',
      'createdAt': '22-11-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '21-01-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '05-10-2018',
      'email': 'calhoun.gordon@google.com'
    },
    {
      '_id': '5c7485e17e694e1e4b8ea735',
      'uuid': '5c7485e17e694e1e4b8ea735',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (875) 492-2583',
      'birthdayDate': '27-10-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Peggy',
      'lastname1': 'Small',
      'lastname2': 'Garrett',
      'username': 'Peggy_Small',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '705 Underhill Avenue',
      'cp': '',
      'photo': 'a7.jpg',
      'avatar': '/static/avatar/a7.jpg',
      'createdAt': '08-01-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '04-03-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '21-12-2018',
      'email': 'peggy.small@google.com'
    },
    {
      '_id': '5c7485e1151349acf0b7bd50',
      'uuid': '5c7485e1151349acf0b7bd50',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (888) 523-3108',
      'birthdayDate': '13-11-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Marsha',
      'lastname1': 'Hicks',
      'lastname2': 'Johnston',
      'username': 'Marsha_Hicks',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '433 Garfield Place',
      'cp': '',
      'photo': 'a2.jpg',
      'avatar': '/static/avatar/a2.jpg',
      'createdAt': '24-03-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '09-10-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '11-05-2018',
      'email': 'marsha.hicks@google.com'
    },
    {
      '_id': '5c7485e15a4826b861b67836',
      'uuid': '5c7485e15a4826b861b67836',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (944) 454-2417',
      'birthdayDate': '11-02-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Kaye',
      'lastname1': 'Booker',
      'lastname2': 'Watkins',
      'username': 'Kaye_Booker',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '720 Taaffe Place',
      'cp': '',
      'photo': 'a7.jpg',
      'avatar': '/static/avatar/a7.jpg',
      'createdAt': '02-01-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '30-01-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '02-07-2018',
      'email': 'kaye.booker@google.com'
    },
    {
      '_id': '5c7485e1a0f5f70c6977e0a3',
      'uuid': '5c7485e1a0f5f70c6977e0a3',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (948) 537-3142',
      'birthdayDate': '11-02-2019',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Atkins',
      'lastname1': 'Slater',
      'lastname2': 'Nieves',
      'username': 'Atkins_Slater',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '488 Logan Street',
      'cp': '',
      'photo': 'a9.jpg',
      'avatar': '/static/avatar/a9.jpg',
      'createdAt': '17-06-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '13-08-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '03-02-2018',
      'email': 'atkins.slater@google.com'
    },
    {
      '_id': '5c7485e1c838fb98394ea181',
      'uuid': '5c7485e1c838fb98394ea181',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (924) 430-2831',
      'birthdayDate': '28-01-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Riggs',
      'lastname1': 'Mclean',
      'lastname2': 'Howell',
      'username': 'Riggs_Mclean',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '976 Gilmore Court',
      'cp': '',
      'photo': 'a3.jpg',
      'avatar': '/static/avatar/a3.jpg',
      'createdAt': '13-12-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '01-07-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '05-11-2018',
      'email': 'riggs.mclean@google.com'
    },
    {
      '_id': '5c7485e121408de748cbc5da',
      'uuid': '5c7485e121408de748cbc5da',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': false,
      'password': null,
      'telf': '+1 (817) 506-3799',
      'birthdayDate': '13-01-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Coffey',
      'lastname1': 'Walton',
      'lastname2': 'Bray',
      'username': 'Coffey_Walton',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '235 Irwin Street',
      'cp': '',
      'photo': 'a1.jpg',
      'avatar': '/static/avatar/a1.jpg',
      'createdAt': '05-03-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '25-11-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '13-12-2018',
      'email': 'coffey.walton@google.com'
    },
    {
      '_id': '5c7485e15ab0f485b862cb27',
      'uuid': '5c7485e15ab0f485b862cb27',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (979) 444-2172',
      'birthdayDate': '25-09-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Branch',
      'lastname1': 'Salinas',
      'lastname2': 'Holloway',
      'username': 'Branch_Salinas',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '699 Claver Place',
      'cp': '',
      'photo': 'a5.jpg',
      'avatar': '/static/avatar/a5.jpg',
      'createdAt': '26-01-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '17-03-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '27-07-2018',
      'email': 'branch.salinas@google.com'
    },
    {
      '_id': '5c7485e1f81cdbeed2e9d6e0',
      'uuid': '5c7485e1f81cdbeed2e9d6e0',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (904) 490-2513',
      'birthdayDate': '02-08-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Mable',
      'lastname1': 'Parker',
      'lastname2': 'Rasmussen',
      'username': 'Mable_Parker',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '714 Lafayette Walk',
      'cp': '',
      'photo': 'a4.jpg',
      'avatar': '/static/avatar/a4.jpg',
      'createdAt': '01-06-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '03-12-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '01-06-2018',
      'email': 'mable.parker@google.com'
    },
    {
      '_id': '5c7485e140e3199a45fcb45d',
      'uuid': '5c7485e140e3199a45fcb45d',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (993) 599-3225',
      'birthdayDate': '13-10-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Ramsey',
      'lastname1': 'Holcomb',
      'lastname2': 'Rice',
      'username': 'Ramsey_Holcomb',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '216 Lott Street',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '10-10-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '25-02-2019',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '02-11-2018',
      'email': 'ramsey.holcomb@google.com'
    },
    {
      '_id': '5c7485e12246b7a8d76c47f9',
      'uuid': '5c7485e12246b7a8d76c47f9',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (887) 410-3997',
      'birthdayDate': '18-06-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Nash',
      'lastname1': 'Medina',
      'lastname2': 'Fitzpatrick',
      'username': 'Nash_Medina',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '915 Jamison Lane',
      'cp': '',
      'photo': 'a7.jpg',
      'avatar': '/static/avatar/a7.jpg',
      'createdAt': '05-03-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '19-06-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '22-11-2018',
      'email': 'nash.medina@google.com'
    },
    {
      '_id': '5c7485e13334bc638232af8d',
      'uuid': '5c7485e13334bc638232af8d',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (975) 413-3267',
      'birthdayDate': '13-01-2018',
      'gender': 'male',
      'register': 'backoffice',
      'name': 'Karyn',
      'lastname1': 'Parsons',
      'lastname2': 'Atkins',
      'username': 'Karyn_Parsons',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '939 Prospect Street',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '18-05-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '20-01-2019',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '01-02-2018',
      'email': 'karyn.parsons@google.com'
    },
    {
      '_id': '5c7485e1934bba91f7193f4e',
      'uuid': '5c7485e1934bba91f7193f4e',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': false,
      'deleted': true,
      'password': null,
      'telf': '+1 (853) 438-2525',
      'birthdayDate': '28-05-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Rachelle',
      'lastname1': 'Calhoun',
      'lastname2': 'Murray',
      'username': 'Rachelle_Calhoun',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '268 Visitation Place',
      'cp': '',
      'photo': 'a2.jpg',
      'avatar': '/static/avatar/a2.jpg',
      'createdAt': '29-07-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '07-02-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '07-11-2018',
      'email': 'rachelle.calhoun@google.com'
    },
    {
      '_id': '5c7485e106210310d8567f1a',
      'uuid': '5c7485e106210310d8567f1a',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (974) 558-2926',
      'birthdayDate': '11-02-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Adela',
      'lastname1': 'Lowery',
      'lastname2': 'Cobb',
      'username': 'Adela_Lowery',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '228 Hunterfly Place',
      'cp': '',
      'photo': 'a7.jpg',
      'avatar': '/static/avatar/a7.jpg',
      'createdAt': '17-01-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '19-09-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '01-05-2018',
      'email': 'adela.lowery@google.com'
    },
    {
      '_id': '5c7485e1a0d470ed8ecd166b',
      'uuid': '5c7485e1a0d470ed8ecd166b',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': false,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (939) 531-2622',
      'birthdayDate': '17-06-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Frank',
      'lastname1': 'Avila',
      'lastname2': 'West',
      'username': 'Frank_Avila',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '380 Coventry Road',
      'cp': '',
      'photo': 'a5.jpg',
      'avatar': '/static/avatar/a5.jpg',
      'createdAt': '21-12-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '10-09-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '05-12-2018',
      'email': 'frank.avila@google.com'
    },
    {
      '_id': '5c7485e10392156d3ea20660',
      'uuid': '5c7485e10392156d3ea20660',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (968) 493-3641',
      'birthdayDate': '15-01-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Joy',
      'lastname1': 'Beck',
      'lastname2': 'Stewart',
      'username': 'Joy_Beck',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '557 Bartlett Place',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '21-12-2018',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '17-10-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '23-12-2018',
      'email': 'joy.beck@google.com'
    },
    {
      '_id': '5c7485e1f51499de326d5435',
      'uuid': '5c7485e1f51499de326d5435',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': false,
      'password': null,
      'telf': '+1 (853) 412-3988',
      'birthdayDate': '14-09-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Robin',
      'lastname1': 'Mccoy',
      'lastname2': 'Cabrera',
      'username': 'Robin_Mccoy',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '369 Hausman Street',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '14-02-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '31-08-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '20-09-2018',
      'email': 'robin.mccoy@google.com'
    },
    {
      '_id': '5c7485e16029f0bd4477ecfc',
      'uuid': '5c7485e16029f0bd4477ecfc',
      'roles': [
        {
          'roleId': '5c48af2bffa4f22f4a5611de',
          'objectId': '5bd9f961e7179a1b5300a7bd',
          'confirm': true
        }
      ],
      'validated': true,
      'active': true,
      'deleted': true,
      'password': null,
      'telf': '+1 (977) 579-2963',
      'birthdayDate': '02-05-2018',
      'gender': 'female',
      'register': 'backoffice',
      'name': 'Minnie',
      'lastname1': 'Melendez',
      'lastname2': 'Trujillo',
      'username': 'Minnie_Melendez',
      'countryId': '5bd9f623e7179a1b5300a5c7',
      'provinceId': '5bd9f689e7179a1b5300a625',
      'townId': '5c5361d2ef9fda1b3cd9671e',
      'address': '204 Greene Avenue',
      'cp': '',
      'photo': 'a8.jpg',
      'avatar': '/static/avatar/a8.jpg',
      'createdAt': '24-02-2019',
      'createdBy': '5bd9f961e7179a1b5300a7bd',
      'updatedAt': '29-03-2018',
      'updatedBy': '5bd9f961e7179a1b5300a7bd',
      'lastAccess': '25-03-2018',
      'email': 'minnie.melendez@google.com'
    }
  ]

const getUserById = (id) => {
  return (id === undefined) ? Items[0] : Items.find(x => x._id === id)
}

const getUser = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items
}

export {
  Items,
  getUser,
  getUserById
}

/**
 {
 _id: ''
 roles: [{
 roleId: "5c48af2bffa4f22f4a5611de",                   // Identificador de la collection ‘roles’.
    objectId: "5bd9f961e7179a1b5300a7bd",              // Identificador según el tipo ('entities', 'teams' 'tournaments', 'matches' 'users', 'all')
    confirm: true,
 }],
 validated: true,
 active: true,
 deleted: false,
 email: '',
 password: null,
 telf: '',
 birthdayDate: '',
 gender: 'male',
 register: 'backoffice',
 name: '',
 username: '',
 lastname1: '',
 lastname2: '',
 countryId: '',
 provinceId: '',
 townId: '',
 address: '',
 cp: '',
 photo: '',
 createdAt: '',
 createdBy: '',
 updatedAt: '',
 updatedBy: '',
 lastAccess: ''
 }
 *
 * businessId: { type: [String], unique: false, required: true },                                                              // Identificador/res del negocio al que pertenece.
 roles: { type: [RolesSchema], unique: false, required: false },                                                             // Roles del usuario.
 validated: { type: Boolean, default: false, unique: false, required: true },                                                // Usuario validado o no validado.
 active: { type: Boolean, default: false, unique: false, required: true },                                                   // Usuario activado o desactivado.
 deleted: { type: Boolean, default: false, unique: false, required: false },                                                 // Si se ha eliminado el usuario.
 email: { type: String, trim: true, lowercase: true, unique: false, required: true },                                        // Email del usuario.
 password: { type: String, select: false, unique: false, required: false },                                                  // Contraseña del usuario.
 telf: { type: String, trim: true, unique: false, required: false },                                                         // Número de teléfono.
 devices: { type: [DevicesSchema], unique: false, required: false },                                                         // Dispositivos y token de envío de notificaciones que tiene el usuario.
 birthdayDate: { type: Date, unique: false, required: false },                                                               // Fecha de nacimiento del usuario.
 gender: { type: String, enum: ['male','female'], unique: false, required: false },                                          // Sexo del usuario.
 register: { type: String, enum: ['google','facebook','direct','guest','backoffice'], unique: false, required: true },       // Tipo de registro.
 name: { type: String, trim: true, unique: false, required: true },                                                          // Nombre del usuario.
 lastname1: { type: String, trim: true, unique: false, required: true },                                                     // Primer apellido.
 lastname2: { type: String, trim: true, unique: false, required: false },                                                    // Segundo apellido.
 countryId: { type: String, unique: false, required: true },                                                                 // Identificador del país del usuario.
 provinceId: { type: String, unique: false, required: true },                                                                // Identificador de la provincia del usuario.
 townId: { type: String, unique: false, required: true },                                                                    // Identificador de la ciudad del usuario.
 address: { type: String, trim: true, unique: false, required: false },                                                      // Dirección del usuario.
 cp: { type: String, trim: true, unique: false, required: false },                                                           // Código postal del usuario.
 photo: { type: String, trim: true, unique: false, required: false },                                                        // Ruta de la imagen del usuario.
 createdAt: { type: Date, unique: false, required: false },                                                                  // Fecha de creación / registro del usuario.
 createdBy: { type: String, unique: false, required: false },                                                                // Identificador del usuario que lo ha creado.
 updatedAt: { type: Date, unique: false, required: false },                                                                  // Fecha de actualización.
 updatedBy: { type: String, unique: false, required: false },                                                                // Identificador del usuario que ha hecho la última actualización.
 lastAccess: { type: Date, unique: false, required: false },                                                                 // Último acceso del usuario.
 tutorId: { type: [String], unique: false },                                                                                 // Identificador de los usuarios tutores legales, obligatorio cuando sean menores.
 following: { type: [FollowingSchema], unique: false, required: false },                                                     // Identificadores de lo que sigue el usuario.
 notes: { type: [NotesSchema], unique: false, required: false },                                                             // Notas del usuario. Como eventos, pero privados que anota el usuario en vídeos.
 lat: { type: Number, unique: false, required: false },                                                                      // Latitud de las coordenadas de la ubicación del usuario.
 long: { type: Number, unique: false, required: false },
 */

/**
 * Roles
 * "5bd9f3ef7fa5610014fed3d0" // admin
 * "5c48af2bffa4f22f4a5611de" // programador
 */
/**
 * https://next.json-generator.com/
 [
 {
    'repeat(30, 50)': {
    _id: '{{objectId()}}',
      uuid() { return `${this._id}`; } ,
    roles: [{
      roleId: "5c48af2bffa4f22f4a5611de",
      objectId: "5bd9f961e7179a1b5300a7bd",
      confirm: true,
    }],
    validated: '{{bool()}}',
    active: '{{bool()}}',
    deleted: '{{bool()}}',
    password: null,
    telf: '+1 {{phone()}}',
    birthdayDate: '{{moment(this.date(new Date(2018, 0, 1), new Date())).format("DD-MM-YYYY")}}',
    gender: '{{random("male", "female")}}',
    register: 'backoffice',
    name: '{{firstName()}}',
    lastname1: '{{surname()}}',
    lastname2: '{{surname()}}',
    username() { return `${this.name}_${this.lastname1}`; },
    countryId: '5bd9f623e7179a1b5300a5c7',
    provinceId: '5bd9f689e7179a1b5300a625',
    townId: '5c5361d2ef9fda1b3cd9671e',
    address: '{{integer(100, 999)}} {{street()}}',
    cp: '',
    photo: 'a{{integer(1, 9)}}.jpg',
    createdAt: '{{moment(this.date(new Date(2018, 0, 1), new Date())).format("DD-MM-YYYY")}}',
    createdBy: "5bd9f961e7179a1b5300a7bd",
    updatedAt: '{{moment(this.date(new Date(2018, 0, 1), new Date())).format("DD-MM-YYYY")}}',
    updatedBy: "5bd9f961e7179a1b5300a7bd",
    lastAccess: '{{moment(this.date(new Date(2018, 0, 1), new Date())).format("DD-MM-YYYY")}}',
      email() {
        return (`${this.name}.${this.lastname1}@google.com`).toLowerCase();
      }
    }
  }
 ]
 */
